/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CouponHalResponse } from '../../models/coupon-hal-response';

export interface CouponsCouponIdGet$Params {
  'Active-Tenant-Identifier': string;
  couponId: string;
}

export function couponsCouponIdGet(http: HttpClient, rootUrl: string, params: CouponsCouponIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponHalResponse>> {
  const rb = new RequestBuilder(rootUrl, couponsCouponIdGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('couponId', params.couponId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CouponHalResponse>;
    })
  );
}

couponsCouponIdGet.PATH = '/coupons/{couponId}';
